// src/pages/News/News.jsx
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './css/news.css';

const News = () => {
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState(null);

  // 取得列表並附加原始鍵
  const newsList = useMemo(() => {
    const listObj = t('news.list', { returnObjects: true });
    if (!listObj || typeof listObj !== 'object') return [];
    return Object.entries(listObj).map(([key, value]) => ({ ...value, _key: key }));
  }, [t]);

  // 依物件鍵取得文章
  const articleData = useMemo(() => {
    if (!selectedKey) return null;
    const data = t(`news.list.${selectedKey}`, { returnObjects: true });
    return typeof data === 'object' ? data : null;
  }, [selectedKey, t]);

  return (
    <div className="news-page min-h-screen bg-gray-50">
      <section className="news-section relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-bold mb-4">{t('news.title')}</h1>
          <p className="text-xl text-white">{t('news.subtitle')}</p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-12">
        {!selectedKey && (
          <div className="grid gap-6">
            {newsList.map(n => (
              <div
                key={n._key}
                className="bg-white shadow hover:shadow-lg transition rounded-lg p-6 cursor-pointer"
                onClick={() => setSelectedKey(n._key)}
              >
                <h2 className="text-2xl font-semibold mb-2">{n.title}</h2>
                <p className="text-sm text-gray-500 mb-4">{n.date}</p>
                <p className="text-gray-700">{n.summary}</p>
                <button className="mt-4 text-blue-600 hover:underline">
                  {t('news.readMore')}
                </button>
              </div>
            ))}
          </div>
        )}

        {selectedKey && articleData && (
          <article className="bg-white shadow rounded-lg p-8">
            <h1 className="text-3xl font-bold mb-2">{articleData.title}</h1>
            <p className="text-sm text-gray-500 mb-8">{articleData.date}</p>
            <div className="space-y-10">
              {Array.isArray(articleData.sections) &&
                articleData.sections.map((sec, idx) => {
                  if (sec.type === 'text') {
                    return (
                      <div key={idx}>
                        {sec.title && <h3 className="text-xl font-semibold mb-2">{sec.title}</h3>}
                        <p className="leading-relaxed text-gray-700 whitespace-pre-line">{sec.content}</p>
                      </div>
                    );
                  }
                  if (sec.type === 'image') {
                    return (
                      <div key={idx} className="w-full flex justify-center">
                        <img
                          src={sec.src}
                          alt={sec.alt}
                          className="rounded-lg shadow max-h-96 object-contain"
                          loading="lazy"
                        />
                      </div>
                    );
                  }
                  return null;
                })}
            </div>
            <button
              onClick={() => setSelectedKey(null)}
              className="text-sm text-blue-600 hover:underline mb-6"
            >
              {t('news.back')}
            </button>
          </article>
        )}

        {selectedKey && !articleData && (
          <div className="text-center text-gray-600">{t('news.fallback.title')}</div>
        )}
      </div>
    </div>
  );
};

export default News;